const meta = { requiresAuth: true };

const Goals = () => import(/* webpackChunkName: "goals" */ '@/views/goals/Root');
const GoalsFirstRun = () => import(/* webpackChunkName: "goals-first-run" */ '@/views/goals/Firstrun');
const GoalsForm = () => import(/* webpackChunkName: "goals-form" */ '@/views/goals/form/Index');
const GoalsUpload = () => import(/* webpackChunkName: "goals-upload" */ '@/views/goals/Upload');
const GoalsGeneral = () => import(/* webpackChunkName: "goals-general" */ '@/views/goals/general/Root');
const GoalsGeneralIndex = () => import(/* webpackChunkName: "goals-general-index" */ '@/views/goals/general/Index');
const GoalsDetail = () => import(/* webpackChunkName: "goals-general-detail" */ '@/views/goals/general/Detail');
const GoalsSetting = () => import(/* webpackChunkName: "goals-setting" */ '@/views/goals/Setting');
const GoalsHierarchy = () => import(/* webpackChunkName: "goals-setting" */ '@/views/goals/Hierarchy');

export default [
  {
    path: '/goals',
    component: Goals,
    children: [
      {
        path: '',
        name: 'goals',
        redirect: 'index/individual/ongoing',
      },
      {
        path: '',
        name: 'goals_firstrun',
        meta,
        component: GoalsFirstRun,
      },
      {
        path: 'form',
        name: 'goals_create',
        meta,
        component: GoalsForm,
      },
      {
        path: 'hierarchy',
        name: 'goals_hierarchy',
        meta,
        component: GoalsHierarchy,
      },
      {
        path: 'setting',
        name: 'goals_setting',
        meta,
        component: GoalsSetting,
      },

      // General Goals
      {
        path: 'index/:type',
        component: GoalsGeneral,
        children: [
          {
            path: '',
            name: 'goals_index',
            redirect: 'ongoing',
          },
          {
            path: ':status',
            name: 'goals_status_index',
            meta,
            component: GoalsGeneralIndex,
          },
          {
            path: 'detail/:uuid',
            name: 'goals_detail',
            meta,
            component: GoalsDetail,
          },
          {
            path: 'edit/:uuid',
            name: 'goals_edit',
            meta,
            component: GoalsForm,
          },
          {
            path: 'upload',
            name: 'goals_mass_create',
            meta,
            component: GoalsUpload,
          },
        ],
      },

      // Bulk Update & Edit Goals
      {
        path: 'index/:type',
        component: GoalsGeneral,
        children: [
          {
            path: 'bulk-edit',
            name: 'goals_bulk_edit',
            meta,
            component: GoalsUpload,
          },
          {
            path: 'bulk-update',
            name: 'goals_bulk_update',
            meta,
            component: GoalsUpload,
          },
        ],
      },
    ],
  },
];
